"use strict";
const DRAG_THRESHOLD = 5;
function initSlider(wrapper) {
    const inner = wrapper.querySelector(".case-slider__inner");
    if (!inner)
        return;
    const slider = {
        wrapper,
        inner,
        isDown: false,
        startX: 0,
        scrollLeft: 0,
        didDrag: false,
    };
    // Prevent default link behavior during drag
    inner.addEventListener("click", (e) => {
        if (slider.didDrag) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }, true);
    // Prevent browser's native image drag
    inner.addEventListener("dragstart", (e) => {
        e.preventDefault();
    });
    // Mouse down
    inner.addEventListener("mousedown", (e) => {
        if (e.button !== 0)
            return; // Only left mouse button
        slider.isDown = true;
        slider.didDrag = false;
        slider.startX = e.pageX - wrapper.offsetLeft;
        slider.scrollLeft = wrapper.scrollLeft;
        inner.classList.add("is-dragging");
    });
    // Mouse leave
    inner.addEventListener("mouseleave", () => {
        if (!slider.isDown)
            return;
        slider.isDown = false;
        inner.classList.remove("is-dragging");
    });
    // Mouse up
    inner.addEventListener("mouseup", () => {
        if (!slider.isDown)
            return;
        slider.isDown = false;
        inner.classList.remove("is-dragging");
        // Reset drag state after a short delay to allow click event to fire
        setTimeout(() => {
            slider.didDrag = false;
        }, 50);
    });
    // Mouse move
    inner.addEventListener("mousemove", (e) => {
        if (!slider.isDown)
            return;
        e.preventDefault();
        const x = e.pageX - wrapper.offsetLeft;
        const walk = x - slider.startX;
        // Mark as dragging if threshold exceeded
        if (Math.abs(walk) > DRAG_THRESHOLD) {
            slider.didDrag = true;
        }
        wrapper.scrollLeft = slider.scrollLeft - walk;
    });
    // Touch start
    let touchStartX = 0;
    let touchScrollLeft = 0;
    wrapper.addEventListener("touchstart", (e) => {
        touchStartX = e.touches[0].pageX - wrapper.offsetLeft;
        touchScrollLeft = wrapper.scrollLeft;
    }, { passive: true });
    // Touch move
    wrapper.addEventListener("touchmove", (e) => {
        const x = e.touches[0].pageX - wrapper.offsetLeft;
        const walk = x - touchStartX;
        wrapper.scrollLeft = touchScrollLeft - walk;
    }, { passive: true });
}
// Initialize all case sliders on the page
function initAllSliders() {
    const sliders = document.querySelectorAll("[data-case-slider]");
    sliders.forEach((slider) => {
        if (slider instanceof HTMLElement) {
            initSlider(slider);
        }
    });
}
// Also run after window load for dynamic content
window.addNavigationCallback(initAllSliders, "init-slider");
